import { useRouter } from 'next/router';
import { returnFirstIfArray } from '@/utils/helpers';

export function useQueryParams(
  ...paramNames: string[]
): (string | undefined)[] {
  const { query } = useRouter();
  return paramNames.map(paramName => returnFirstIfArray(query[paramName]));
}
